export default __webpack_public_path__ + "static/media/INSIGHTS-ANALYTICS.6ceae564.jpg";